import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=5d7ff040&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"
import style0 from "./RegisterView.vue?vue&type=style&index=0&id=5d7ff040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ff040",
  null
  
)

export default component.exports